import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular/standalone';
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent } from '@ionic/angular/standalone';
import {Store} from "@ngrx/store";
import {OrganisationUserSelectors} from "../../index";
import {Organisation} from "../../../organisation";
import {CommonModule} from '@angular/common';
import {SexyModule} from '@qid/sexy';
import {SuperButtonComponent, AvatarRoundComponent} from '@qid/super';

@Component({
  selector: 'app-organisation-selector',
  templateUrl: './organisation-selector.component.html',
  styleUrls: ['./organisation-selector.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent
  ],
})
export class OrganisationSelectorComponent implements OnInit {

  public userOrganisations$ = this.store.select(OrganisationUserSelectors.selectUserOrganisations)

  constructor(private modalController: ModalController,
              private store: Store
  ) {
  }

  ngOnInit() {

  }

  close() {
    this.modalController.dismiss({organisation: null})
  }

  onOrgSelect(org: Organisation) {
    this.modalController.dismiss({
      organisation: org
    })
  }
}
